export const formatCurrency = (value) => {
  const n = Number(value || 0);
  return `Rp ${n.toLocaleString('id-ID')}`;
};

export const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

export const severityTone = (severity) => {
  const normalized = String(severity || '').toUpperCase();
  if (normalized === 'CRITICAL') return 'border-red-500/60 bg-red-500/15 text-red-100';
  if (normalized === 'HIGH') return 'border-amber-500/60 bg-amber-500/15 text-amber-100';
  if (normalized === 'MEDIUM') return 'border-blue-500/60 bg-blue-500/15 text-blue-100';
  return 'border-emerald-500/60 bg-emerald-500/15 text-emerald-100';
};

export const healthTone = (value, lowThreshold, highThreshold) => {
  const v = Number(value || 0);
  if (v >= highThreshold) return 'text-red-300';
  if (v >= lowThreshold) return 'text-amber-300';
  return 'text-emerald-300';
};
